import React, { useState } from "react";
import "./footer.css";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import Swal from "sweetalert2"; // Import sweetalert2
const  apiurl = "https://truthexpserver.onrender.com/api"
//process.env.REACT_APP_API_BASE_URL
const Footer = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!name || !email || !message) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill out all fields.",
      });
      return;
    }

    // Submit to backend
    fetch(`${apiurl}/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, email, message }),
    })
      .then((res) => res.json())
      .then((data) => {
        Swal.fire({
          icon: "success",
          title: "Message sent successfully!",
          text: "Thank you for reaching out. We will get back to you soon.",
        });
        setName("");
        setEmail("");
        setMessage("");
      })
      .catch((error) => {
        console.error("Submission failed:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to submit",
          text: "There was an error submitting your message. Please try again later.",
        });
      });
  };

  return (
    <footer className="footer-container">
      <div className="footer-content container">
        <div className="footer-top">
          <p className="brand-name">
            <img src="/white-logo.png" alt="Logo" />
          </p>
          <h2>Truth Experienced</h2>
          <p className="footer-text">Follow Us On</p>
          <div className="footer-links">
            <a
              href="https://www.instagram.com/truthexperienced/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              <FaInstagram color="#fff" />
            </a>

            <a
              href="https://www.facebook.com/amanpatel222"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              <FaFacebookF color="#fff" />
            </a>

            <a
              href="https://www.youtube.com/@truthExperienced"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              <FaYoutube size={22} color="#fff" />
            </a>
          </div>
        </div>
        <div className="line"></div>
        <div className="footer-form">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value || "")}
            />
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value || "")}
            />
            <textarea
              placeholder="Enter your message"
              value={message}
              onChange={(e) => setMessage(e.target.value || "")}
            ></textarea>
            <button type="submit" className="footer-button">Send</button>
          </form>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="copyright-text">
          © {new Date().getFullYear()} Truth Experienced. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
